import { Header } from "@/components/Header";
import type { AmountLayoutProps } from "./AmountLayoutProps";
import classes from "./AmountLayout.module.scss";
import { clsx } from "clsx";
import { Footer } from "@/components/Footer";
import { Container } from "@/components/ui/Container";
import { useAppConfig } from "@/hooks/useAppConfig";

export function AmountLayout(props: AmountLayoutProps) {
  const { children, className } = props;
  const { image } = useAppConfig();

  return (
    <div className={clsx(classes.page, className)}>
      <Header />

      <main className={classes.main}>
        <Container maxWidth="lg">
          <div className={classes.layout}>
            <div className={classes.content}>{children}</div>

            <div className={classes.aside}>
              <img src={image} alt="" className={classes.picture} />
            </div>
          </div>
        </Container>
      </main>

      <Footer />
    </div>
  );
}
